import { Box, BoxProps, ColorOptions, TextNew } from '@jfs/ui-new'
import { useEffect } from 'react'
import { useWindowDimensions } from 'react-native'
import ActionsMenu from '../../../components/ActionMenu/ActionsMenu'
import { hasItemAccess } from '../../../components/ExpandList'
import { NewTable } from '../../../components/NewTable'
import { menuItems } from '../../../data'
import { useLazyApiData, useStores } from '../../../data/store'
import { FullScreenLoader } from '../OnboardEntity/comps/FullScreenLoader'

const GlobalSearchList = ({ route: { params }, navigation }) => {
  console.log('htag props=', params?.entityList)
  const { globalSearchString, searchEntityAsyncNew, searchFilterBy, accessConfig } = useStores((store) => ({
    globalSearchString: store.onboarding.globalSearchString,
    searchEntityAsyncNew: store.entityOnboarding.searchEntityAsyncNew,
    searchFilterBy: store.onboarding.searchFilterBy,
    accessConfig: store.user.accessConfig,
  }))
  const { width } = useWindowDimensions()
  const savedData = JSON.parse(localStorage.getItem('globalSearchData') ?? '{}')

  const [searchApi, searchHandler] = useLazyApiData(searchEntityAsyncNew)
  const entityList = searchHandler?.data ?? params?.entityList ?? savedData?.entityList
  useEffect(() => {
    if (!entityList || entityList?.length === 0 || (!params?.entityList && savedData?.entityList?.length === 1)) {
      const pathToNavigate =
        menuItems
          .find((menuItem) => menuItem.name === 'Entity Onboarding')
          ?.subRights?.find((subItem) => hasItemAccess(subItem?.path?.slice(1), accessConfig))
          ?.path?.slice(1) ?? 'home'

      navigation.reset({
        index: 0,
        routes: [{ name: pathToNavigate }],
      })
    } else if (entityList?.length === 1) {
      navigation.reset({
        index: 0,
        routes: [{ name: 'globalSearchEntityDetails', params: { item: entityList[0] } }],
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box {...styles.container}>
      <Box ph={16} pt={16}>
        <TextNew
          title={`${entityList?.length ?? 0} Search result for "${
            globalSearchString ? globalSearchString : savedData?.searchString
          }" found`}
          color={'BLACK_21'}
          fontSize={18}
          fontFamily={'jiotype-bold'}
        />
      </Box>
      <Box p={16}>
        <ActionsMenu
          fetchDataOnChange={() => {
            searchApi(
              globalSearchString ? globalSearchString : savedData?.searchString,
              searchFilterBy ?? savedData?.searchFilterBy,
            )
          }}
          showSearch={false}
          enableFilter={false}
          showCalendar={false}
          showSearchByEntityId={false}
          defaultPage={1}
        />
      </Box>
      <NewTable
        data={entityList ?? []}
        rowHeight={48}
        headerHeight={64}
        height={544}
        customWidthFunc={getCustomColumnWidth}
        tableWidth={width > 1200 ? width - 290 : width}
        headerRowKeys={checker1HeaderTitles}
        onRowClick={(item) => {
          navigation.navigate('globalSearchEntityDetails', { item: item })
        }}
        onRetry={() => {}}
      />
      <FullScreenLoader show={searchHandler?.state === 'pending'} />
    </Box>
  )
}

export default GlobalSearchList

const styles = {
  container: {
    borderRadius: 8,
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    height: '100%',
  } as BoxProps,
}

const getCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    applicationId: 100,
    businessLegalName: 100,
    landlineNumber: 100,
    requestType: 100,
    programCategory: 100,
    createdAt: 100,
    applicationStatus: 100,
  }
  return columnsKeyWidth[columnKey] ?? 150
}

const checker1HeaderTitles = {
  applicationId: 'Entity Id',
  parentSubGroupId: 'Parent Id',
  businessLegalName: 'Legal Name',
  personalMobileNumber: 'Mobile Number',
  createdAt: 'Activation Date & Time',
}
